module.exports = __webpack_public_path__ + "img/tres-indicadores-pre-natal.81351ff3.svg";